import { render, staticRenderFns } from "./crudProductsCompound.vue?vue&type=template&id=3ed58894&"
import script from "./crudProductsCompound.vue?vue&type=script&lang=js&"
export * from "./crudProductsCompound.vue?vue&type=script&lang=js&"
import style0 from "./crudProductsCompound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports